const noticeError = (error, customAttributes) => {
    if (!error)
        throw new Error('An error should be specified for monitoring');
    if (process.env.NODE_ENV !== 'production') {
        // Do not log errors from development/testing environments
        return;
    }
    const nrAvailable = !!window.newrelic;
    if (nrAvailable) {
        window.newrelic.noticeError(error, customAttributes);
    }
};
export { noticeError };
